<template>
  <v-layout class="fill-height">
    <div class="flex mx-1" style="flex: 2;">
      <v-menu
          ref="menu"
          v-model="menu"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="auto"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
              flat
              solo
              dense
              hide-details
              v-model="currentDateRanger"
              label="Date Ranger"
              placeholder="Date Ranger"
              readonly
              v-bind="attrs"
              v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
            v-model="currentDateRanger"
            range
        ></v-date-picker>
      </v-menu>
    </div>
    <div class="flex mx-1" style="flex: 1.5;">
      <v-autocomplete
          @change="getDistrict"
          v-model="currentState"
          :items="states"
          label="All State"
          placeholder="All State"
          flat
          solo
          hide-details
          dense
          item-text="name"
          item-value="id"
          class="select-box"
          :disabled="loading"
          clearable
      >
      </v-autocomplete>
    </div>
    <div class="flex mx-1" style="flex: 1.5;">
      <v-autocomplete
          @change="getCircle"
          v-model="currentDistrict"
          :items="districts"
          label="All District"
          placeholder="All District"
          flat
          solo
          hide-details
          dense
          item-text="name"
          item-value="id"
          class="select-box"
          :disabled="loading"
          clearable
      >
      </v-autocomplete>
    </div>
    <div class="flex mx-1" style="flex: 1.5;">
      <v-autocomplete
          @change="getVillage"
          v-model="currentCircle"
          :items="circles"
          label="All Circles"
          placeholder="All Circle"
          flat
          solo
          hide-details
          dense
          item-text="name"
          item-value="id"
          class="select-box"
          :disabled="loading"
          clearable
      >
      </v-autocomplete>
    </div>
    <div class="flex mx-1" style="flex: 1.5;">
      <v-autocomplete
          v-model="currentVillage"
          :items="villages"
          label="All Villages"
          placeholder="All Village"
          flat
          solo
          hide-details
          dense
          item-text="name"
          item-value="id"
          class="select-box"
          :disabled="loading"
          clearable
      >
      </v-autocomplete>
    </div>
    <div class="flex mx-1" style="flex: 2;">
      <v-autocomplete
          v-model="currentType"
          :items="surveys"
          label="All Type"
          placeholder="All Type"
          flat
          solo
          hide-details
          dense
          item-text="name"
          item-value="id"
          class="select-box"
          :disabled="loading"
          clearable
      >
      </v-autocomplete>
    </div>
    <div class="flex mx-1" style="flex: 2;">
      <v-layout class="fill-height px-1" align-center justify-end>
        <div style="border: #fafafa 2px solid; border-radius: 4px; margin-top: -4px" class="mr-1">
          <v-btn title="Refresh" height="34" width="95" min-width="0" style="font-size: 10px;"
                 @click="refreshFilter"
                 color="info" class="elevation-0">
            <v-icon size="20">mdi-refresh</v-icon>
            Refresh
          </v-btn>
        </div>
        <v-menu
            :close-on-content-click="false"
            absolute
            offset-y
            style="width: 300px"
        >
          <template v-slot:activator="{ on, attrs }">
            <div style="border: #fafafa 2px solid; border-radius: 4px; margin-top: -4px" class="ml-1">
              <v-btn
                  v-bind="attrs"
                  v-on="on"
                  :disabled="!currentType"
                  title="Download"
                  height="34"
                  width="95"
                  min-width="0"
                  style="font-size: 10px;"
                  color="info"
                  class="elevation-0">
                <v-icon size="20">mdi-download</v-icon>
                Download
              </v-btn>
            </div>
          </template>

          <v-list dense color="backgroundForm" width="230">
            <v-hover v-slot="{ hover }" v-for="(action, index) in status" :key="index">
              <v-list-item color="#893FF2" :style="{'background-color': hover ? 'var(--v-backgroundList-base)' : ''}">
                <v-list-item-title :style="{'color': action.color}">{{ action.name }}</v-list-item-title>
                <v-list-item-action>
                  <v-layout justify-end>
                    <v-btn v-if="!action.onlyXlsx" title="*.geojson" color="primary" fab x-small class="mr-1 elevation-0" @click="downloadData(action.name, action.code, 'geojson')">
                      <v-icon size="16" color="white">mdi-code-json</v-icon>
                    </v-btn>
                    <v-btn title="*.xlsx" color="primary" fab x-small class="ml-1" @click="downloadData(action.name, action.code, 'xlsx', action.onlyXlsx)" >
                      <v-icon size="16" color="white">mdi-file-excel-outline</v-icon>
                    </v-btn>
                  </v-layout>
                </v-list-item-action>
              </v-list-item>
            </v-hover>
          </v-list>
        </v-menu>
      </v-layout>
    </div>
  </v-layout>
</template>

<script>
import {mapState} from "@/store/ults";
import {getDistrict, getCircle, getVillage} from "@/backend";

export default {
  name: "FilterForm",
  data() {
    return {
      status: [
        {
          name: 'All Farms',
          code: undefined,
          color: '#4aa94e'
        },
        {
          name: 'Pending Farms',
          code: 1,
          color: '#8008fa'
        },
        {
          name: 'Verified Farms',
          code: 2,
          color: '#2974ff'
        },
        {
          name: 'Modified Farms',
          code: 3,
          color: '#ff6229'
        },
        {
          name: 'Rejected Farms',
          code: 4,
          color: '#ff2929'
        },
        {
          name: 'DCS Data Farms',
          code: undefined,
          color: '#4aa94e',
          onlyXlsx: true
        }
      ],
      loading: false,
      menu: false,
      districts: [],
      circles: [],
      villages: [],
    }
  },
  props: {
    dateRanger: {type: Array, default: []},
    state: {type: Number, default: undefined},
    district: {type: Number, default: undefined},
    circle: {type: Number, default: undefined},
    village: {type: Number, default: undefined},
    type: {type: String, default: undefined}
  },
  computed: {
    ...mapState("dashboard", ["states", "surveys"]),
    currentDateRanger: {
      get() {
        return this.dateRanger
      },
      set(val) {
        this.$emit('update:dateRanger', val)
      }
    },
    currentSeason: {
      get() {
        return this.season
      },
      set(val) {
        this.$emit('update:season', val)
      }
    },
    currentCountry: {
      get() {
        return this.country
      },
      set(val) {
        this.$emit('update:country', val)
      }
    },
    currentState: {
      get() {
        return this.state
      },
      set(val) {
        this.$emit('update:state', val)
      }
    },
    currentDistrict: {
      get() {
        return this.district
      },
      set(val) {
        this.$emit('update:district', val)
      }
    },
    currentCircle: {
      get() {
        return this.circle
      },
      set(val) {
        this.$emit('update:circle', val)
      }
    },
    currentVillage: {
      get() {
        return this.village
      },
      set(val) {
        this.$emit('update:village', val)
      }
    },
    currentType: {
      get() {
        return this.type
      },
      set(val) {
        this.$emit('update:type', val)
      }
    }
  },
  methods: {
    async getDistrict(stateId) {
      this.districts = []
      this.circles = []
      this.villages = []
      if (!stateId) return
      try {
        this.loading = true
        const res = await getDistrict({parent_id: stateId})
        this.districts = res.data
      } catch (e) {

      } finally {
        this.loading = false
      }
    },
    async getCircle(districtId) {
      this.circles = []
      this.villages = []
      if (!districtId) return
      try {
        this.loading = true
        const res = await getCircle({parent_id: districtId})
        this.circles = res.data
      } catch (e) {

      } finally {
        this.loading = false
      }
    },
    async getVillage(circleId) {
      this.villages = []
      if (!circleId) return
      try {
        this.loading = true
        const res = await getVillage({parent_id: circleId})
        this.villages = res.data
      } catch (e) {

      } finally {
        this.loading = false
      }
    },
    refreshFilter() {
      this.currentState = undefined
      this.getDistrict()
    },
    downloadData(name, status, type, isDcsData) {
      this.$emit('downloadData', name, status, type, isDcsData)
    }
  }
}
</script>

<style scoped>

</style>
